var _linearGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineDrawing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 136,
    viewBox: "0 0 110 136",
    width: 110,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "82.467716%",
    x2: "17.532284%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8c74"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.170005 22.8412814v-22.8412814l27.390002 27.1920017h-23.0076017c-2.4199066 0-4.3824003-1.9483069-4.3824003-4.3507203zm23.007601 113.1187266h-100.79520573c-2.41990665 0-4.38240027-1.946947-4.38240027-4.35072v-127.25856773c0-2.40241335 1.96249362-4.35072027 4.38240027-4.35072027h74.91165463v24.7827903c0 2.906825 2.3747131 5.2643715 5.3027043 5.2643715h24.9632478v101.5621262c0 2.403773-1.962494 4.35072-4.382401 4.35072z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.374179 94.380006h52.131649",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.2204045 34.3200021-44.1804027 44.1817227v8.6182806h8.6182805l44.1817227-44.1810628zm-5.1684603 8.1925805 5.1684603-5.1691203 5.6040603 5.5948203-5.1691203 5.1697804zm-36.8583623 36.8570423 35.3509222-35.1370822 5.6034003 5.6034004-35.3502621 35.1377421h-5.6040604z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDrawing);
export default __webpack_public_path__ + "static/media/line_drawing.9aa0912bcce6676b749ae01478810a19.svg";
export { ForwardRef as ReactComponent };